import axios from "axios";
const baseUrl = process.env.REACT_APP_API_URL;

export const isStripeConnected = (token) => {
  let config = {
    method: "get",
    maxBodyLength: Infinity,
    url: `${baseUrl}/api/payment/isvalidstripeaccount`,
    headers: {
      token: token,
    },
  };

  const res = axios
    .request(config)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      console.log("error in isStripeConnected: ", error?.response?.data);
      return error?.response?.data;
    });

  return res;
};

export const generateStripeLink = (token, countryCode) => {
  let data = JSON.stringify({
    country: countryCode,
  });

  let config = {
    method: "post",
    maxBodyLength: Infinity,
    url: `${baseUrl}/api/payment/createpaymentaccount`,
    headers: {
      token: token,
      "Content-Type": "application/json",
    },
    data: data,
  };

  const res = axios
    .request(config)
    .then((response) => {
      return response?.data;
    })
    .catch((error) => {
      console.log("error in generateStripeLink: ", error);
      return error?.response?.data;
    });
  return res;
};

export const createPayment = (token, id) => {
  let data = JSON.stringify({
    transaction_id: id,
    product_name: "yacht berth",
  });

  let config = {
    method: "post",
    maxBodyLength: Infinity,
    url: `${baseUrl}/api/payment/createpayment`,
    headers: {
      token: token,
      "Content-Type": "application/json",
    },
    data: data,
  };

  const res = axios
    .request(config)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      console.log("error in createPayment: ", error);
      return error?.response?.data;
    });
  return res;
};

export const paymentStatus = (token, id) => {
  let payload = JSON.stringify({
    session_id: id,
  });

  let config = {
    method: "post",
    maxBodyLength: Infinity,
    url: `${baseUrl}/api/payment/getpaymentdetails`,
    headers: {
      token: token,
      "Content-Type": "application/json",
    },
    data: payload,
  };

  const res = axios
    .request(config)
    .then((response) => {
      return response?.data;
    })
    .catch((error) => {
      console.log("error in paymentStatus: ", error);
      return error?.response?.data;
    });
  return res;
};

export const updatePaymentStatus = (sessionId, orderId, token) => {
  let data = JSON.stringify({
    transaction_id: orderId,
    session_id: sessionId,
    status: "paid",
  });

  let config = {
    method: "post",
    maxBodyLength: Infinity,
    url: `${baseUrl}/api/payment/updatepaymentstatus`,
    headers: {
      token: token,
      "Content-Type": "application/json",
    },
    data: data,
  };

  const res = axios
    .request(config)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      console.log("error in updatePaymentStatus: ", error?.response?.data);
      return error?.response?.data;
    });
  return res;
};

export const paymentHistory = (token) => {
  let config = {
    method: "get",
    maxBodyLength: Infinity,
    url: `${baseUrl}/api/payment/paymentsessiondetails`,
    headers: {
      token: token,
    },
  };

  const res = axios
    .request(config)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      console.log("error in payment status: ", error);
      return error?.response?.data;
    });
  return res;
};